import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ChromePicker} from 'react-color';

import Modal from 'components/Modal';
import useModal from 'hooks/useModal';
import useSession from 'hooks/useSession';
import useGroup from 'hooks/useGroup';

function ModalSetting(props) {
	const {t} = useTranslation();

	const {
		setFetchingGroup,
		disabled
	} = props;

	const {
		isShowing,
		hide,
		show
	} = useModal();

	const {
		session,
		setup,
		updateSetup,
		getPixelValue
	} = useSession();


	const {
		group,
		addGroup
	} = useGroup(setup, getPixelValue, session);

	const [size, setSize] = useState({
		marginV: setup.marginVertical,
		marginH: setup.marginHorizontal,
		width: setup.domino.size.width,
		height: setup.domino.size.height,
		heightFallWall: setup.domino.size.heightFallWall,
		thickness: setup.domino.size.thickness,
		type: setup.type
	});

	const beforeEndUpdateSetup = (data) => {
		if (group !== false && group.main !== true) {
			if (group.config && group.config.setup) {
				let setupGroup = group.config.setup;
				let setup = data.setup;
				if (
					setupGroup.marginHorizontal !== setup.marginHorizontal ||
					setupGroup.marginVertical !== setup.marginVertical ||
					setupGroup.domino.size.width !== setup.width ||
					setupGroup.domino.size.height !== setup.height ||
					setupGroup.domino.size.thickness !== setup.thickness ||
					setupGroup.domino.size.heightFallWall !== setup.heightFallWall ||
					setupGroup.type !== setup.type
				) {
					let affirm = window.confirm(t('ModalSetting.rebuildGroup'));
					if (affirm) {
						setFetchingGroup(true);
						let params = {...group.config};
						params.setup.marginHorizontal = setup.marginHorizontal;
						params.setup.marginVertical = setup.marginVertical;
						params.setup.domino.size.width = setup.width;
						params.setup.domino.size.height = setup.height;
						params.setup.domino.size.thickness = setup.thickness;
						params.setup.domino.size.heightFallWall = setup.heightFallWall;
						params.setup.type = setup.type;
						params.groupId = group.id;
						params.name = group.name;
						delete params.width;
						delete params.maxHeight;
						delete params.maxWidth;
						delete params.height;

						addGroup(params);
					}
				}
			}
		}
		//props.onEndUpdateSetup(data);
		hide();
	}

	const updateSize = (key, value) => {
		if (value) {
			let temp = {...size};
			temp[key] = value;
			setSize(temp);
		}
	}

	const valid = () => {
		updateSetup({
			...size,
			bgColor: color,
			session
		}, beforeEndUpdateSetup);
	}

	const [color, setColor] = useState(setup.backgroundColor);

	/*useEffect(() => {
		if (setup && setup.backgroundColor && setup.backgroundColor !== color) {
			updateSetup({
				bgColor: color,
				session
			}, beforeEndUpdateSetup);
		}
	}, [color])*/

	return (
		<>
			<button
				type="button"
				className={'btntool btn btn-primary p-0' + (disabled ? ' disabled' : '')}
				onClick={show}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<circle cx="12" cy="12" r="3"></circle>
					<path
						d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
				</svg>
			</button>
			<Modal
				isShowing={isShowing}
				hide={hide}
				title={t('ModalSetting.title')}
				className="ModalSetting"
			>
				<div className="setting-modal">
					<div className="row g-3">
						<div className="input-group mb-3" key="block1">
							<label className="input-group-text"
							       htmlFor="inputGroupSelect01">{t('ModalSetting.form.type')}</label>
							<select
								className="form-select"
								id="inputGroupSelect01"
								value={size.type}
								onChange={(evt) => {
									updateSize('type', parseFloat(evt.target.value));
								}}
							>
								<option value="1">{t('ModalSetting.form.types.vertical')}</option>
								<option value="2">{t('ModalSetting.form.types.horizontal')}</option>
								<option value="3">{t('ModalSetting.form.types.fallWall')}</option>
							</select>
						</div>
						<hr />
					</div>
					<div className="row g-3">
						<div className="col-md-6">
							<label htmlFor="inputPassword4"
							       className="form-label">{t('ModalSetting.form.bgcolor')}</label>
							<ChromePicker
								color={color}
								disableAlpha={true}
								onChangeComplete={(c) => {
									setColor(c.hex);
								}}
							/>
						</div>
						<div className="col-md-6">
							{Object.keys(size).map((key, index) => {
								if (key === 'type') {
									return (null);
								}
								if (parseInt(size.type, 10) !== 3 && key === 'heightFallWall') {
									return (null);
								}

								if (
									parseInt(size.type, 10) === 3 &&
									(
										key === 'marginH' ||
										key === 'thickness' ||
										key === 'height'
									)
								) {
									return (null);
								}

								if (
									parseInt(size.type, 10) !== 3 &&
									(
										key === 'height'
									)
								) {
									return (null);
								}
								return (
									<div key={'input-' + index} className="props-setting">
										<label htmlFor="nbr-domino"
										       className="form-label">{t('ModalSetting.form.' + key)}</label>
										<br />
										<input
											type="text"
											className="form-control"
											defaultValue={size[key]}
											onChange={(evt) => {
												evt.target.value = evt.target.value.replace(',', '.');
												updateSize(key, parseFloat(evt.target.value));
											}}
										/>
									</div>
								);
							})}
						</div>
					</div>
					<br />
					<div className="row">
						<button
							onClick={valid}
							type="submit"
							className="btn btn-primary btn-save"
						>
							{t('ModalSetting.save')}
						</button>
					</div>
				</div>


			</Modal>
		</>
	);
}

export default ModalSetting;
